import UnstyledImage from '@components/Image';
import styled  from 'styled-components';
import { Caption } from '@components/type';
import { mq } from '@utils/responsive';
import { CONTENT_MAX_WIDTH, H_PADDING_MOBILE } from '@utils/space';

export const ImageWrapper = styled.div`
  flex-grow: 1;


`;

export const Image = styled(UnstyledImage)`
  margin: 0 0 10px 0;

  ${mq.gtsm`
    margin: 5px
  `}
`;

export const DoubleCaption = styled(Caption)`
  flex: 0 0 100%;
  ${mq.gtsm`
    margin: 5px
  `}
`;

export const Wrapper = styled.div`
  width: 95%;
  margin: 0 auto;
  vertical-align: top;

  ${mq.gtsm`
    width: ${(7 / 12) * 100}%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
  `}
`;

export const SizedWrapper = styled.div`
  width: 100%;
  padding: 0 ${H_PADDING_MOBILE};

  ${mq.gtmd`
    width: ${(props) => props.$rowWidth}px;
    max-width: min(calc(100% - ${H_PADDING_MOBILE} * 2), ${CONTENT_MAX_WIDTH}px);
    margin: 0 auto;
    padding: 0;
  `}
`;

export const SizedRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.$gap}px;

  ${mq.gtmd`
    flex-direction: row;
    align-items: flex-start;
  `}
`;

export const SizedItem = styled.div`
  width: ${(props) => props.$mobileWidth}px;
  max-width: 100%;

  ${mq.gtmd`
    flex: ${(props) => props.$ratio} 1 0%;
    width: auto;
    min-width: 0;
  `}
`;

export const SizedImage = styled(UnstyledImage)``;

export const SizedCaption = styled(Caption)`
  margin-top: 8px;

  ${mq.gtsm`
    margin-top: 16px;
  `}
`;
